import { Component, Input } from '@angular/core';

@Component({
  selector: 'info-tooltip',
  styleUrls: ['./info-tooltip.component.scss'],
  template: `
      <a *ngIf="description" class="info-link" [tooltip]="description" [placement]="position" [show-delay]="delay">
          <i class="fa fa-info"></i>
      </a>
  `
})
export class InfoTooltipComponent {

  @Input() description: string;
  @Input() position = 'bottom';
  @Input() delay = 20;
}
